/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */

import isAssetMgmt from '../components/is/assetMgmt/routerPaths';
import isFm from '../components/is/fm/routerPaths';
import isHeatMonitoring from '../components/is/heatMonitoring/routerPaths';

// Relative to /src/views
// eslint-disable-next-line no-sparse-arrays
export default [
  {
    path: '/',
    name: 'Login',
    view: 'login',
    alias: ['/login'],
    meta: {
      i18n: 'Common.appTitle',
      noAuth: true,
    },
  },
  {
    path: '/home',
    name: 'Home',
    view: 'home',
    meta: {
      i18n: 'Common.drawer.home',
      isDrawerIconLink: true,
    },
  },

  ...isAssetMgmt.routerPaths,
  ...isFm.routerPaths,
  ...isHeatMonitoring.routerPaths,

  // DIGITAL TWINS
  {
    path: '/digitaltwin-state-overview',
    name: 'DigitalTwinStatesOverview',
    view: 'digitalTwin/digitalTwinStatesOverview',
    meta: {
      i18n: 'Common.drawer.dTwinStateOverview',
      permissions: {
        or: [
          {
            and: [
              { subject: 'DigitalTwinStates', action: 'read' },
              { subject: 'DigitalTwin', action: 'list' },
            ],
          },
          { subject: 'DigitalTwin', action: 'read' },
        ],
      },
    },
  },
  {
    path: '/digitaltwin-mgmt',
    name: 'DigitalTwinOverview',
    view: 'digitalTwin/digitalTwinOverview',
    meta: {
      i18n: 'Common.drawer.dTwins',
      isDrawerIconLink: true,
      permissions: { subject: 'DigitalTwin', action: 'read' },
    },
  },
  {
    path: '/digitaltwin-mgmt/list',
    name: 'DigitalTwinList',
    view: 'digitalTwin/digitalTwinList',
    meta: {
      i18n: 'Common.drawer.dTwins',
      isDrawerIconLink: true,
      permissions: { subject: 'DigitalTwin', action: 'read' },
    },
  },
  {
    path: '/digitaltwin-mgmt/:id',
    name: 'DigitalTwinDetails',
    view: 'digitalTwin/digitalTwinDetails',
    meta: {
      i18n: 'Common.drawer.dTwins',
      permissions: { subject: 'DigitalTwin', action: 'read' },
    },
  },
  {
    path: '/digitaltwin-mgmt/map/twin/:twinId',
    name: 'DigitalTwinMap',
    view: 'digitalTwin/digitalTwinMap',
    meta: {
      i18n: 'Common.drawer.dTwins',
      permissions: { subject: 'DigitalTwin', action: 'read' },
    },
  },
  {
    path: '/digitaltwin/rules-monitor',
    name: 'DigitalTwinRulesMonitor',
    view: 'digitalTwin/digitalTwinRulesMonitor',
    meta: {
      i18n: 'Common.drawer.dTwinRulesMonitor',
      isDrawerIconLink: true,
      permissions: { subject: 'DigitalTwin', action: 'read' },
    },
  },

  // VIRTUAL DEVICE DRIVERS

  {
    path: '/virtual-device-drivers',
    name: 'VirtualDeviceDriverList',
    view: 'virtualDevices/driver/list',
    meta: {
      i18n: 'Common.drawer.virtualDeviceDrivers',
      isDrawerIconLink: true,
      permissions: {
        or: [
          { subject: 'DeviceDriver', action: 'read' },
          { subject: 'DeviceDriver', action: 'manage' },
        ],
      },
    },
  },

  {
    path: '/virtual-device-drivers/:id',
    name: 'VirtualDeviceDriverDetails',
    view: 'virtualDevices/driver/details',
    meta: {
      permissions: {
        or: [
          { subject: 'DeviceDriver', action: 'read' },
          { subject: 'DeviceDriver', action: 'manage' },
        ],
      },
    },
  },

  // VIRTUAL DEVICES

  {
    path: '/virtual-devices',
    name: 'VirtualDevicesList',
    view: 'virtualDevices/list',
    meta: {
      i18n: 'Common.drawer.virtualDevices',
      isDrawerIconLink: true,
      permissions: {
        or: [
          { subject: 'VirtualDevice', action: 'manage' },
          { subject: 'VirtualDevice', action: 'read' },
        ],
      },
    },
  },
  {
    path: '/virtual-devices/map',
    name: 'VirtualDevicesMap',
    view: 'virtualDevices/map',
    meta: {
      i18n: 'Common.drawer.virtualDevices',
      isDrawerIconLink: true,
      permissions: {
        or: [
          { subject: 'VirtualDevice', action: 'manage' },
          { subject: 'VirtualDevice', action: 'read' },
        ],
      },
    },
  },
  {
    path: '/virtual-device-groups/map',
    name: 'VirtualDevicesViewMap',
    view: 'virtualDevices/map',
    meta: {
      i18n: 'Common.drawer.virtualDevices',
      isDrawerIconLink: true,
      permissions: {
        or: [
          { subject: 'VirtualDevice', action: 'manage' },
          { subject: 'VirtualDevice', action: 'read' },
        ],
      },
    },
  },
  {
    path: '/virtual-device-groups/:id',
    name: 'VirtualDevicesViewMonitoring',
    view: 'virtualDevices/viewDetails',
    meta: {
      i18n: 'Common.drawer.monitoringViews',
      isDrawerIconLink: true,
      permissions: {
        or: [{ subject: 'VirtualDevice', action: 'read' }],
      },
    },
  },
  {
    path: '/virtual-device-groups',
    name: 'VirtualDevicesViews',
    view: 'virtualDevices/views',
    meta: {
      i18n: 'Common.drawer.monitoringViews',
      isDrawerIconLink: true,
      permissions: {
        or: [{ subject: 'VirtualDevice', action: 'read' }],
      },
    },
  },
  {
    path: '/virtual-devices/:id',
    name: 'VirtualDevicesDetails',
    view: 'virtualDevices/details',
    meta: {
      i18n: 'Common.drawer.virtualDevices',
      permissions: {
        or: [
          { subject: 'VirtualDevice', action: 'manage' },
          { subject: 'VirtualDevice', action: 'read' },
        ],
      },
    },
  },

  // DEVICE TEMPLATES

  {
    path: '/device-templates',
    name: 'DeviceTemplates',
    view: 'deviceTemplates/list',
    meta: {
      i18n: 'Common.drawer.deviceTemplates',
      isDrawerIconLink: true,
      permissions: {
        or: [
          { subject: 'DeviceTemplate', action: 'read' },
          { subject: 'DeviceTemplate', action: 'manage' },
        ],
      },
    },
  },
  {
    path: '/device-templates/:id',
    name: 'DeviceTemplatesDetails',
    view: 'deviceTemplates/details',
    meta: {
      i18n: 'Common.drawer.deviceTemplates',
      permissions: {
        or: [
          { subject: 'DeviceTemplate', action: 'read' },
          { subject: 'DeviceTemplate', action: 'manage' },
        ],
      },
    },
  },

  // ACCOUNT / ADMIN
  {
    path: '/account-mgmt',
    name: 'AccountManagement',
    view: 'accountMgmt/accountMgmtOverview',
    meta: {
      i18n: 'Common.drawer.accountMgmt',
      isDrawerIconLink: true,
      permissions: {
        or: [
          { subject: 'UserManagement', action: 'create' },
          { subject: 'UserManagement', action: 'read' },
        ],
      },
    },
  },
  {
    path: '/account-mgmt/:tenantId?',
    name: 'AccountManagementOverview',
    view: 'accountMgmt/accountMgmtOverview',
    meta: {
      i18n: 'Common.drawer.accountMgmt',
      permissions: {
        or: [
          { subject: 'UserManagement', action: 'create' },
          { subject: 'UserManagement', action: 'read' },
        ],
      },
    },
  },
  {
    path: '/account-mgmt/user/:tenantId/',
    name: 'AccountManagementUserList',
    view: 'accountMgmt/accountMgmtUserDetails',
    meta: {
      i18n: 'Common.userCreateHead',
      permissions: { subject: 'UserManagement', action: 'create' },
    },
  },
  {
    path: '/account-mgmt/user-bulk-create/:tenantId/',
    name: 'AccountManagementUserBulkCreate',
    view: 'accountMgmt/accountMgmtUserBulkCreate',
    meta: {
      i18n: 'Common.userCreateHead',
      permissions: { subject: 'UserManagement', action: 'create' },
    },
  },
  {
    path: '/account-mgmt/user/:tenantId/:id',
    name: 'AccountManagementUserDetails',
    view: 'accountMgmt/accountMgmtUserDetails',
    meta: {
      i18n: 'Common.userEditHead',
      permissions: { subject: 'UserManagement', action: 'manage' },
    },
  },
  {
    path: '/account-mgmt-roles',
    name: 'AccountManagementRoleEditor',
    view: 'accountMgmt/accountMgmtRoleEditor',
    meta: {
      i18n: 'Common.drawer.accountMgmtRoleEditor',
      permissions: { subject: 'all', action: 'manage' },
    },
  },
  {
    path: '/system-logs',
    name: 'SystemLogs',
    view: 'accountMgmt/accountMgmtLogs',
    meta: {
      i18n: 'Common.drawer.systemLogs',
      permissions: { subject: 'all', action: 'manage' },
    },
  },
  {
    path: '/system-settings',
    name: 'SystemSettings',
    view: 'accountMgmt/accountMgmtSettings',
    meta: {
      i18n: 'Common.drawer.systemsettings',
      permissions: { subject: 'all', action: 'manage' },
    },
  },
  {
    path: '/drawer-links',
    name: 'DrawerLinks',
    view: 'accountMgmt/accountMgmtDrawerLinks',
    meta: {
      i18n: 'DRAWERLINKS',
      permissions: { subject: 'super.system', action: 'manage' },
    },
  },
  {
    path: '/account-mgmt-announcements',
    name: 'AccountManagementAnnouncements',
    view: 'accountMgmt/accountMgmtAnnouncement',
    meta: {
      i18n: 'Common.drawer.accountMgmtAnnouncement',
      permissions: { subject: 'all', action: 'manage' },
    },
  },
  {
    path: '/account-mgmt-modules',
    name: 'AccountManagementModules',
    view: 'accountMgmt/accountMgmtModules',
    meta: {
      i18n: 'Common.drawer.accountMgmtModules',
      permissions: { subject: 'all', action: 'manage' },
    },
  },
  {
    path: '/superadmin-terminal',
    name: 'AccountManagementAdminTerminal',
    view: 'accountMgmt/accountMgmtSuperAdminTerminal',
    meta: {
      i18n: 'Common.drawer.systemTerminal',
      permissions: { subject: 'super.system', action: 'manage' },
    },
  },

  // SCHEDULED EXPORTS
  {
    path: '/scheduled-exports',
    name: 'ScheduledExports',
    view: 'scheduledExports/scheduledExportsList',
    meta: {
      i18n: 'BackgroundJobs.ScheduledExports.title',
    },
  },

  // BACKGROUND JOBS
  {
    path: '/background-jobs',
    name: 'BackgroundJobList',
    view: 'backgroundJobs/backgroundJobList',
    meta: {
      i18n: 'BackgroundJobs.BackgroundJobs.title',
      permissions: {
        or: [
          { subject: 'DigitalTwin', action: 'read' },
          { subject: 'IotHub', action: 'read' },
          { subject: 'VirtualDevice', action: 'read' },
        ],
      },
    },
  },

  // CONNECTORS & CONSUMERS
  {
    path: '/connectors/list',
    name: 'ConnectorsList',
    view: 'connectors/list',
    meta: {
      i18n: 'accMgmt.tenant.bridges.title',
      permissions: { subject: 'all', action: 'manage' },
    },
  },
  {
    path: '/connectors/create',
    name: 'ConnectorsCreate',
    view: 'connectors/create',
    meta: {
      i18n: 'accMgmt.tenant.bridges.title',
      permissions: { subject: 'all', action: 'manage' },
    },
  },
  {
    path: '/connectors/edit/:account/:id',
    name: 'ConnectorsEdit',
    view: 'connectors/create',
    meta: {
      i18n: 'accMgmt.tenant.bridges.title',
      permissions: { subject: 'all', action: 'manage' },
    },
  },
  {
    path: '/connectors/consumers/list',
    name: 'ConnectorsChains',
    view: 'connectors/consumers/chains',
    meta: {
      i18n: 'Bridges.Consumers.drawer.integrationsFlows',
      permissions: { subject: 'all', action: 'manage' },
    },
  },
  {
    path: '/connectors/consumers/filters',
    name: 'ConnectorsFilters',
    view: 'connectors/consumers/filters',
    meta: {
      i18n: 'Bridges.Consumers.drawer.filters',
      permissions: { subject: 'all', action: 'manage' },
    },
  },
  {
    path: '/connectors/consumers/transformers',
    name: 'ConnectorsTransformers',
    view: 'connectors/consumers/transformers',
    meta: {
      i18n: 'Bridges.Consumers.drawer.transformers',
      permissions: { subject: 'all', action: 'manage' },
    },
  },
  {
    path: '/connectors/consumers/transformers/create',
    name: 'ConnectorsTransformersCreate',
    view: 'connectors/consumers/transformersEdit',
    meta: {
      i18n: 'Bridges.Consumers.drawer.transformers',
      permissions: { subject: 'all', action: 'manage' },
    },
  },
  {
    path: '/connectors/consumers/transformers/:id',
    name: 'ConnectorsTransformersEdit',
    view: 'connectors/consumers/transformersEdit',
    meta: {
      i18n: 'Bridges.Consumers.drawer.transformers',
      permissions: { subject: 'all', action: 'manage' },
    },
  },

  // NIOTA CLASSIC
  // Applications
  {
    path: '/niota-classic/applications',
    name: 'NiotaClassicApplicationsList',
    view: 'niotaClassic/applications/applicationsList',
    meta: {
      i18n: 'NiotaClassic.Applications.title',
      permissions: { subject: 'IotHub', action: 'read' },
    },
  },
  {
    path: '/niota-classic/originators',
    name: 'NiotaClassicOriginators',
    view: 'niotaClassic/originators',
    meta: {
      i18n: 'NiotaClassic.Originators.title',
      permissions: { subject: 'IotHub', action: 'read' },
    },
  },
  // {
  //   path: 'https://fireflyiot.com',
  //   meta: {
  //     i18n: 'NiotaClassic.Applications.title',
  //     permissions: { subject: 'IotHub', action: 'read' },
  //   },
  // },
  {
    path: '/niota-classic/applications/:applicationId/details',
    name: 'NiotaClassicApplicationDetails',
    view: 'niotaClassic/applications/applicationDetails',
    meta: {
      i18n: 'NiotaClassic.Devices.title',
      permissions: { subject: 'IotHub', action: 'read' },
    },
  },
  {
    path: '/niota-classic/devices',
    name: 'NiotaClassicDevicesList',
    view: 'niotaClassic/devices/devicesList',
    meta: {
      i18n: 'NiotaClassic.Devices.title',
      permissions: { subject: 'IotHub', action: 'read' },
    },
  },
  {
    path: '/niota-classic/devices/:deviceId/details',
    name: 'NiotaClassicDeviceDetails',
    view: 'niotaClassic/devices/deviceDetails',
    meta: {
      i18n: 'NiotaClassic.Devices.upload',
      permissions: { subject: 'IotHub', action: 'read' },
    },
  },
  {
    path: '/niota-classic/devices/csv/upload',
    name: 'NiotaClassicDeviceUpload',
    view: 'niotaClassic/devices/deviceUpload',
    meta: {
      i18n: 'NiotaClassic.Devices.title',
      permissions: { subject: 'IotHub', action: 'manage' },
    },
  },
  {
    path: '/niota-classic/device-types',
    name: 'NiotaClassicDeviceTypesList',
    view: 'niotaClassic/deviceTypes/deviceTypesList',
    meta: {
      i18n: 'NiotaClassic.DeviceTypes.title',
      permissions: {
        or: [
          { subject: 'IotHub', action: 'read' },
          { subject: 'VirtualDevice', action: 'read' },
        ],
      },
    },
  },
  {
    path: '/niota-classic/device-monitoring',
    name: 'NiotaClassicDeviceMonitoring',
    view: 'niotaClassic/deviceMonitoring',
    meta: {
      i18n: 'NiotaClassic.DeviceMonitoring.title',
      permissions: { subject: 'IotHub', action: 'read' },
    },
  },
  {
    path: '/niota-classic/gw-mgmt',
    name: 'NiotaClassicGatewayManagement',
    view: 'niotaClassic/gatewayManagement/gwManagement',
    meta: {
      i18n: 'NiotaClassic.GWMonitoring.title',
      permissions: {
        or: [
          { subject: 'IotHub', action: 'read' },
          { subject: 'all', action: 'read' },
        ],
      },
    },
  },
  {
    path: '/niota-classic/gw-mgmt/:gatewayId/details',
    name: 'NiotaClassicGatewayManagementDetails',
    view: 'niotaClassic/gatewayManagement/gwDetails',
    meta: {
      i18n: 'NiotaClassic.GWMonitoring.title',
      permissions: {
        or: [
          { subject: 'IotHub', action: 'read' },
          { subject: 'all', action: 'read' },
        ],
      },
    },
  },
  {
    path: '/niota-classic/gw-mgmt/map/:accountId/gateways',
    name: 'NiotaClassicGatewayManagementMap',
    view: 'niotaClassic/gatewayManagement/gwMap',
    meta: {
      i18n: 'NiotaClassic.DeviceTypes.title',
      permissions: {
        or: [
          { subject: 'IotHub', action: 'read' },
          { subject: 'all', action: 'read' },
        ],
      },
    },
  },
  {
    path: '/niota-classic/device-types/:deviceTypeId/details',
    name: 'NiotaClassicDeviceTypesDetails',
    view: 'niotaClassic/deviceTypes/deviceTypesDetails',
    meta: {
      i18n: 'NiotaClassic.DataSources.title',
      permissions: { subject: 'IotHub', action: 'read' },
    },
  },
  {
    path: '/niota-classic/data-sources',
    name: 'NiotaClassicDataSources',
    view: 'niotaClassic/dataSources',
    meta: {
      i18n: 'NiotaClassic.DataSources.title',
      permissions: { subject: 'IotHub', action: 'read' },
    },
  },
  {
    path: '/niota-classic/consumers',
    name: 'NiotaClassicConsumerList',
    view: 'niotaClassic/consumers/consumerList',
    meta: {
      i18n: 'NiotaClassic.Consumers.title',
      permissions: { subject: 'IotHub', action: 'read' },
    },
  },
  {
    path: '/niota-classic/consumers/:id',
    name: 'NiotaClassicConsumerDetails',
    view: 'niotaClassic/consumers/consumerDetails',
    meta: {
      i18n: 'NiotaClassic.ServiceBuilders.title',
      permissions: { subject: 'IotHub', action: 'read' },
    },
  },
  {
    path: '/niota-classic/service-builders',
    name: 'NiotaClassicServiceBuilders',
    view: 'niotaClassic/serviceBuilders',
    meta: {
      i18n: 'NiotaClassic.ServiceBuilders.title',
      permissions: { subject: 'all', action: 'manage' },
    },
  },

  // IS-Warnapp
  {
    path: '/is-warnapp-viewer',
    name: 'WarnApp',
    view: 'is/warnapp/viewer',
    meta: {
      i18n: 'IS.Warnapp.drawer.isWarnappAdmin',
      isDrawerIconLink: true,
      permissions: {
        or: [
          { subject: 'IsWarnapp', action: 'read' },
          { subject: 'IsWarnapp', action: 'manage' },
        ],
      },
      hideLayout: true,
    },
  },
  {
    path: '/is-warnapp-admin',
    name: 'WarnAppAdmin',
    view: 'is/warnapp/admin',
    meta: {
      i18n: 'Common.usrPrflHead',
      permissions: { subject: 'IsWarnapp', action: 'manage' },
    },
  },

  // MONITORING

  {
    path: '/alarm-logs',
    name: 'AlarmLogs',
    view: 'alarmLogs/list',
    meta: {
      i18n: 'Common.alarmLogs',
      permissions: { subject: 'VirtualDevice', action: 'read' },
    },
  },

  {
    path: '/alarm-log-reports',
    name: 'AlarmLogsReportList',
    view: 'alarmLogs/reportList',
    meta: {
      i18n: 'Common.alarmReports',
      permissions: { subject: 'VirtualDevice', action: 'manage' },
    },
  },

  // MISC
  {
    path: '/user-profile',
    name: 'UserProfile',
    view: 'userProfile',
    meta: {
      i18n: 'Common.drawer.userProfile',
    },
  },
  {
    path: '/help',
    name: 'Help',
    view: 'help',
  },
  {
    path: '/api',
    name: 'Api',
    view: 'api',
    meta: {
      i18n: 'Common.drawer.api',
    },
  },
  {
    path: '/error',
    name: 'Error',
    view: 'error',
    meta: {
      i18n: 'Fehler',
      noAuth: true,
    },
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    view: 'resetPassword',
    meta: {
      i18n: 'ResetPassword',
      noAuth: true,
    },
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    view: 'changePassword',
    meta: {
      i18n: 'ChangePassword',
      noAuth: true,
    },
  },
  {
    path: '/oauth',
    name: 'OauthConsent',
    view: 'oauthConsent',
    meta: {
      i18n: 'OauthConsent',
      noAuth: true,
    },
  },

  // PUBLIC
  {
    path: '/public/:key/tiles/:id',
    name: 'PublicTiles',
    view: 'public/tiles',
    meta: {
      i18n: 'PublicTiles',
      noAuth: true,
      hideLayout: true,
    },
  },
  {
    path: '/public/:key/map/:twinId',
    name: 'PublicMap',
    view: 'public/map',
    meta: {
      i18n: 'PublicMap',
      fullHeight: true,
      noAuth: true,
      hideLayout: true,
    },
  },
];
